module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('boxWrap', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "name": _vm.name
    }
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "main"
  }, [(_vm.tableData.length != 0) ? _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-wrap",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.tableData), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "item"
    }, [_vm._v(_vm._s(item.area))]), _vm._v(" "), _c('div', {
      staticClass: "item"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "item red"
    }, [_vm._v("红榜")])])
  }), 1) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4201f1f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/recordInformation/table/index.vue
// module id = 1991
// module chunks = 2